/**
 * Client-side fetch wrapper for BFF (Browser ↔ admin Next.js BFF) calls.
 *
 * All BFF↔API fetches MUST go through this. Direct `fetch()` calls inside
 * `apps/admin/src/components/` are caught by the ESLint rule
 * `no-restricted-syntax` (see `apps/admin/eslint.config.mjs`). The rule
 * exists because cross-origin deploys (CDN-fronted) silently 401 when the
 * browser doesn't send the admin session cookie — adding
 * `credentials: 'include'` here once, in one place, removes the per-call
 * footgun.
 *
 * Behavior:
 *   - Always sets `credentials: 'include'`. Callers cannot override (and
 *     shouldn't need to) — the server-side `AdminApiClient` is the path
 *     for non-cookie API calls.
 *   - Forwards `init.headers` if provided.
 *   - Returns the `Response` unchanged. Body parsing / status handling
 *     stays at the call site so this wrapper does not need to know which
 *     endpoints return JSON vs. 204 vs. octet-stream.
 *
 * Equivalent in spirit to `proxy.ts`'s `AdminApiClient` (server side); this
 * is the missing client-side companion.
 *
 * Per the admin-frontend-hardening-bundle (C-3, 2026-05-11): the eight
 * affected call sites in LearnersIndexClient + bulk-actions stop being
 * cross-origin-401-silent.
 */
export function bffFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  return fetch(input, {
    ...init,
    credentials: 'include',
  });
}
